import { Lightbulb } from 'lucide-react';
import React, { useMemo } from 'react';
import { Button } from '../common';
import { useDashboardContext } from './DashboardContext';

export const SmartInsightCard: React.FC = () => {
  const { dashboard } = useDashboardContext();
  const bestSalesDay = useMemo(() => {
    return (
      dashboard.trend
        .slice()
        .sort((left, right) => right.net_sales - left.net_sales)[0]?.label ||
      '--'
    );
  }, [dashboard.trend]);

  return (
    <div className="relative flex flex-col overflow-hidden rounded-[22px] bg-[#111c14] p-5 text-white shadow-sm lg:col-span-1">
      <div className="flex items-start justify-between">
        <p className="flex items-center gap-1.5 text-[11px] font-medium text-emerald-100/70">
          <Lightbulb size={13} className="text-emerald-400" /> Smart Insight
        </p>
        <div className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500/20">
          <Lightbulb size={14} className="text-emerald-400" />
        </div>
      </div>
      <div className="flex-1 flex flex-col gap-2 justify-center items-center">
        <p className="text-[14px] leading-relaxed text-emerald-50 text-center">
          Peak sales on{' '}
          <span className="font-semibold text-white">{bestSalesDay}</span>.
        </p>
        <p className="text-[12px] leading-relaxed text-emerald-50 text-center">
          Want tips to maintain momentum?
        </p>
      </div>
      <Button
        variant="text"
        className="mt-auto w-full rounded-xl bg-emerald-600 py-2 text-[11px] font-semibold text-white hover:text-black transition-colors hover:bg-emerald-500"
      >
        View Suggestions
      </Button>
    </div>
  );
};
